import { $, extend } from '../core/core';
import { noop } from '../util/misc';
import { ScrollView } from './scrollview';

export const NavigationBase = function (elm, settings, inherit) {
    var $ctx,
        display,
        multiple,
        select,
        selectedClass,
        s,
        $elm = $(elm),
        that = this;

    function removePagePadding() {
        if (display && display != 'inline') {
            $ctx.find('.mbsc-page').css('padding-' + display, '');
        }
    }

    function selectItem($item) {
        $item.addClass(selectedClass).attr('data-selected', 'true').attr('aria-selected', 'true');
    }

    function deselectItem($item) {
        $item.removeClass(selectedClass).removeAttr('data-selected').removeAttr('aria-selected');
    }

    // Call the parent constructor
    ScrollView.call(this, elm, settings, true);

    that.select = function ($item) {
        if (!multiple) {
            deselectItem(that._$items.filter('.mbsc-ms-item-sel'));
        }
        selectItem(that._getItem($item));
    };

    that.deselect = function ($item) {
        deselectItem(that._getItem($item));
    };

    that.enable = function ($item) {
        that._getItem($item)
            .removeClass('mbsc-disabled')
            .removeAttr('data-disabled')
            .removeAttr('aria-disabled');
    };

    that.disable = function ($item) {
        that._getItem($item)
            .addClass('mbsc-disabled')
            .attr('data-disabled', 'true')
            .attr('aria-disabled', 'true');
    };

    that.setBadge = function ($item, content) {
        var $badge;
        $item = that._getItem($item).attr('data-badge', content);
        $badge = $('.mbsc-ms-badge', $item);
        if ($badge.length) {
            if (content) {
                $badge.html(content);
            } else {
                $badge.remove();
            }
        } else if (content) {
            $item.append('<span class="mbsc-ms-badge">' + content + '</span>');
        }
    };

    that._markupReady = function ($cont) {
        if (that._hasIcons) {
            $cont.addClass('mbsc-ms-icons');
        } else {
            $cont.removeClass('mbsc-ms-icons');
        }

        if (that._hasText) {
            $cont.addClass('mbsc-ms-txt');
        } else {
            $cont.removeClass('mbsc-ms-txt');
        }

        that.__markupReady($cont);
    };

    that._size = function (contWidth, itemWidth) {
        that.__size(contWidth, itemWidth);
        // Add space to pages within context
        if (display != 'inline') {
            $ctx.find('.mbsc-page').css('padding-' + display, elm.offsetHeight + 'px');
        }
    };

    that._onItemTap = function ($item, toggle) {
        if (that.__onItemTap($item, toggle) === false) {
            return false;
        }
        if (toggle === undefined) {
            toggle = !multiple;
        }
        if (select && toggle && !$item.hasClass('mbsc-disabled')) {
            if (multiple) {
                if ($item.attr('data-selected') == 'true') {
                    deselectItem($item);
                } else {
                    selectItem($item);
                }
            } else {
                deselectItem(that._$items.filter('.mbsc-ms-item-sel'));
                selectItem($item);
            }
        }
        return toggle;
    };

    that._getActiveItem = function ($item) {
        var selected = $item.attr('data-selected') == 'true';
        if (select && !multiple && selected) {
            return $item;
        }
    };

    that._getItemProps = function ($item) {
        var selected = $item.attr('data-selected') == 'true',
            disabled = $item.attr('data-disabled') == 'true',
            icon = $item.attr('data-icon'),
            badge = $item.attr('data-badge');

        $item
            .attr('data-role', 'button')
            .attr('aria-selected', selected ? 'true' : 'false')
            .attr('aria-disabled', disabled ? 'true' : 'false');

        if (badge) {
            $item.append('<span class="mbsc-ms-badge">' + badge + '</span>');
        }

        if (icon) {
            that._hasIcons = true;
        }

        if ($item.text()) {
            that._hasText = true;
        }

        return {
            cssClass: 'mbsc-ms-item ' +
                (s.itemClass || '') + ' ' +
                (selected ? selectedClass : '') +
                (disabled ? ' mbsc-disabled ' + (s.disabledClass || '') : '') +
                (icon ? ' mbsc-ms-ic mbsc-ic mbsc-ic-' + icon : '')
        };
    };

    that._getContClass = function () {
        return ' mbsc-ms-c mbsc-ms-' + s.variant + ' mbsc-ms-' + display + (select ? '' : ' mbsc-ms-nosel') +
            (that.__getContClass() || '');
    };

    that.__init = function () {
        that.___init();

        $ctx = $(s.context);

        // Remove old padding from mbsc-page
        // if display changed dynamically
        removePagePadding();

        display = s.display;
        multiple = s.select == 'multiple';
        select = s.select != 'off';
        selectedClass = ' mbsc-ms-item-sel ' + (s.activeClass || '');

        $elm.addClass('mbsc-ms mbsc-ms-base ' + (s.groupClass || ''));
    };

    that.__destroy = function () {
        $elm.removeClass('mbsc-ms mbsc-ms-base ' + (s.groupClass || ''));
        removePagePadding();
        that.___destroy();
    };

    that.__onItemTap = noop;
    that.__getContClass = noop;
    that.__markupReady = noop;
    that.__size = noop;
    that.___init = noop;
    that.___destroy = noop;

    // ---

    // Constructor

    s = that.settings;

    if (!inherit) {
        that.init(settings);
    }
};

// Defaults
NavigationBase.prototype = {
    _defaults: extend({}, ScrollView.prototype._defaults)
};



// WEBPACK FOOTER //
// ./src/js/lib/mobiscroll/classes/navigation-base.js